import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .filter('bringozPackagesCount', bringozPackagesCount);

function bringozPackagesCount() {
  return function bringozPackagesCountFilter(packages) {

    let packagesItemsCount;

    if (!!packages) {
      const packagesItems = packages.flatMap(p => p.items);
      packagesItemsCount = packagesItems?.reduce((sum, item) => {
        return sum + item.count || 0;
      }, 0);
    }

    return packagesItemsCount;
  }
}
